import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import "./index.css";
import styles from "./index.css.js";
const sizeStyles = {
  "xs": styles.sizeXS,
  "s": styles.sizeS,
  "m": styles.sizeM,
  "l": styles.sizeL
};
export const Size = {
  "xs": "xs",
  "s": "s",
  "m": "m",
  "l": "l"
};
const PersonIcon16 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1a5.79 5.79 0 0 0-5.64 4.466l-.052.225A1.065 1.065 0 0 0 3.345 14h9.31c.687 0 1.194-.64 1.037-1.309l-.053-.225A5.79 5.79 0 0 0 8 8"
})));
PersonIcon16.displayName = 'PersonIcon16';
const PersonIcon20 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.88 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.12 1a6.76 6.76 0 0 0-6.579 5.21l-.023.098A1.377 1.377 0 0 0 4.738 17h10.523c.888 0 1.544-.828 1.34-1.692l-.022-.097A6.76 6.76 0 0 0 10 10"
})));
PersonIcon20.displayName = 'PersonIcon20';
const PersonIcon24 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.92 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m.08 1a8.1 8.1 0 0 0-7.91 6.345l-.03.137A2.07 2.07 0 0 0 6.08 21h11.84a2.07 2.07 0 0 0 2.02-2.518l-.03-.137A8.1 8.1 0 0 0 12 12"
})));
PersonIcon24.displayName = 'PersonIcon24';
const PersonIcon28 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28"
}, props, {
  ref: ref
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-.592 1a8.85 8.85 0 0 0-8.583 6.702A2.654 2.654 0 0 0 7.4 24h13.2a2.654 2.654 0 0 0 2.575-3.298A8.85 8.85 0 0 0 14.593 14z"
})));
PersonIcon28.displayName = 'PersonIcon28';
const PersonIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    theme,
    size: sizeFromProps = "m",
    className,
    style,
    ['data-render-all-sizes']: renderAllSizes = false,
    ...props
  } = _ref;
  const size = sizeFromProps in Size ? sizeFromProps : "m";
  const mainProps = { ...props,
    className: cn(styles.icon, styles[theme], sizeStyles[size], renderAllSizes && styles.allVariants, className),
    style: renderAllSizes ? {
      '--rs-icon-ar-width': 28,
      '--rs-icon-ar-height': 28,
      ...style
    } : style,
    ref
  };

  if (renderAllSizes) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 28 28"
    }, mainProps), /*#__PURE__*/React.createElement(PersonIcon16, {
      className: styles.variant16
    }), /*#__PURE__*/React.createElement(PersonIcon20, {
      className: styles.variant20
    }), /*#__PURE__*/React.createElement(PersonIcon24, {
      className: styles.variant24
    }), /*#__PURE__*/React.createElement(PersonIcon28, {
      className: styles.variant28
    }));
  }

  if (size === Size['xs']) {
    return /*#__PURE__*/React.createElement(PersonIcon16, mainProps);
  }

  if (size === Size['s']) {
    return /*#__PURE__*/React.createElement(PersonIcon20, mainProps);
  }

  if (size === Size['m']) {
    return /*#__PURE__*/React.createElement(PersonIcon24, mainProps);
  }

  return /*#__PURE__*/React.createElement(PersonIcon28, mainProps);
});
PersonIcon.displayName = 'PersonIcon';
PersonIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"]),
  'data-render-all-sizes': PropTypes.bool,
  style: PropTypes.object
};
export default PersonIcon;
//# sourceMappingURL=person.js.map